import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { FORM_EDITOR_MODE } from '../../common/globals';
import FormDetailsRedux from './FormDetails';
import FormElementDetails from './FormElementDetails';

const FormEditorRightPanel = (props) => {
  const {
    mode,
    teamName,
    onAddElement,
    onFormElementChange,
    onFormElementUIChange,
    selectedElement,
    onFormElementTypeChange,
    onMoveUp,
    onMoveDown,
    onFormElementRemove,
    onFormElementCloseEditor,
    onFormElementRequiredChange,
    onFormElementOptionsChange
  } = props;

  let view;
  
  switch (mode) {
    case FORM_EDITOR_MODE.EDIT_FORM:
      view = (
        <FormDetailsRedux
          teamName={teamName}
          onAddElement={onAddElement}
        />
      );
      break;

    case FORM_EDITOR_MODE.EDIT_FIELD:
      view = (
        <FormElementDetails
          selectedElement={selectedElement}
          onFormElementChange={onFormElementChange}
          onFormElementUIChange={onFormElementUIChange}
          onFormElementTypeChange={onFormElementTypeChange}
          onFormElementRemove={onFormElementRemove}
          onMoveUp={onMoveUp}
          onMoveDown={onMoveDown}
          onFormElementCloseEditor={onFormElementCloseEditor}
          onFormElementRequiredChange={onFormElementRequiredChange}
          onFormElementOptionsChange={onFormElementOptionsChange}
        />
      );
      break;

    case FORM_EDITOR_MODE.ADD_FIELD:
      view = 'Add field component';
      break;

    default:
      break;
  }

  return view;
};

FormEditorRightPanel.defaultProps = {
  additionClasses: '',
  mode: FORM_EDITOR_MODE.EDIT_FORM,
  selectedElement: null,
  onAddElement: () => {},
  formDescription: '',
  onFormElementUIChange: () => {}
};

FormEditorRightPanel.propTypes = {
  additionClasses: PropTypes.string,
  mode: PropTypes.oneOf(_.values(FORM_EDITOR_MODE)),
  teamName: PropTypes.string.isRequired,
  onAddElement: PropTypes.func,
  onFormElementChange: PropTypes.func.isRequired,
  onFormElementUIChange: PropTypes.func,
  onFormElementTypeChange: PropTypes.func.isRequired,
  selectedElement: PropTypes.shape({
    type: PropTypes.string,
    title: PropTypes.string
  }),
  onFormElementRemove: PropTypes.func.isRequired,
  onMoveUp: PropTypes.func.isRequired,
  onMoveDown: PropTypes.func.isRequired,
  onFormElementCloseEditor: PropTypes.func.isRequired,
  onFormElementRequiredChange: PropTypes.func.isRequired,
  onFormElementOptionsChange: PropTypes.func.isRequired
};

export default FormEditorRightPanel;
